<template>
    <section>
        <div id="subHeader">
            <h1>Podcasts</h1>
            <h2>Sente-se e ouça</h2>
        </div>
        <div class="container-fluid" id="main">
            <div class="row">
                <div class="col-12 col-xl-7 mb-5" id="text-stuff-title">
                    <h1>{{ podcast.title }}</h1>
                </div>
                <div class="col-12 col-xl-7 mb-5" id="text-stuff"></div>
                <div class="col">
                    <div class="d-flex px-3">
                        <div class="m-auto">
                            <div class="audio">
                                <audio controls>
                                    <source :src="podcast.audio" :type="podcast.mime">
                                    Your browser does not support the audio element.
                                </audio>
                            </div>
                            <div class="image">
                                <img alt="" id="qsBanner" :src="podcast.image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import TypeIt from "typeit";

    export default {
        name: "Podcast",
        metaInfo() {
            return {
                title: `Podcasts | ${this.podcast.title}`,
            }
        },
        data() {
            return {
                podcast: {}
            }
        },
        mounted() {
            this.$parent.image = '/images/podcasts.jpg';
        },
        beforeRouteEnter(to, from, next) {
            axios.post(`/podcast/${to.params.uuid}`)
                .then(rsp => next(vm => {
                    rsp.data.summary = rsp.data.summary.replace(/(<([^>]+)>)/ig, "");
                    vm.podcast = rsp.data;
                }))
        },
        watch: {
            'podcast': function () {
                new TypeIt('#text-stuff', {
                    speed: 1
                }).type(this.podcast.summary).go();
            }
        }
    }
</script>

<style lang="scss" scoped>
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
    }
</style>